<template>
  <v-container fluid class="py-0">
    <!-- Loader -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Deletion confirmation dialog -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogElimina"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1 headline">
          <v-toolbar-title class="white--text">
            Questo elemento verrà eliminato definitivamente
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-6">
          <h3 style="text-align: left !important">
            Confermi di voler eliminare questo elemento?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="delSelectedItem">ANNULLA</v-btn>
          <v-btn color="green" dark @click="deleteFolder">CONFERMA</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Articolo Lista -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogArticolo"
      width="unset"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">
            Articolo Dettaglio
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                @click="
                  closedetailModal();
                  dialogArticolo = false;
                "
                small
              >
                <v-icon color="red" depressed class="">mdi-window-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text
          style="max-height: 600px; overflow-y: auto; overflow-x: hidden"
          class="mt-6"
        >
          <Articolo
            :articoloId="this.recursiveId"
            :key="this.recursiveId"
            :name="this.recursiveId"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Distinta Base Update dialog -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialog"
      width="1200"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">Distinta Base</v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            bottone_class="saveIcon"
            colore_icona="success"
            idForm="ARTICOLO_DISTINTA_BASE"
            idOggetto="SALVA_ARTICOLO_DISTINTABASE"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva distinta"
            v-on:buttonClick="conferma_save_distinta = true"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="filtro_visible = true"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="primary">mdi-filter</v-icon></v-btn
              >
            </template>
            <span>Visualizza Filtri</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="resetFiltro" small v-bind="attrs" v-on="on"
                ><v-icon color="primary">mdi-filter-off</v-icon></v-btn
              >
            </template>
            <span>Resetta Filtro</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" small @click="hideModal()">
                <v-icon color="red">mdi-window-close</v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-subtitle>
          <v-form v-on:submit.prevent="searchDistintaBase">
            <v-container>
              <v-row>
                <v-col class="d-flex" cols="12" md="3">
                  <v-text-field
                    :disabled="this.disablesearch === true"
                    type="text"
                    v-model="cod_articolo"
                    class="shrink"
                    label="Ricerca Componente"
                    placeholder="Ricerca Componente"
                    required
                  ></v-text-field>
                </v-col>
                <v-col class md="1">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mt-5" @click="searchDistintaBase" small>
                        <v-icon
                          v-on="on"
                          v-bind="attrs"
                          color="#1a80b6"
                          size="32"
                          >mdi-magnify</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Cerca </span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row
                class="mb-2"
                align="center"
                justify="center"
                v-if="filtro_visible"
              >
                <v-col cols="4" md="2">
                  <v-autocomplete
                    background-color="#ffffff"
                    @change="(sub_tipo_search = ''), filtra()"
                    dense
                    hide-details
                    :items="actualItems_backup"
                    item-text="id_tipo"
                    item-value="id_tipo_R"
                    label="Tipo"
                    style="display: inline-block; max-width: 350px"
                    v-model="tipo_search"
                  >
                    <template v-slot:append>
                      <v-icon
                        class="ml-2"
                        @click="
                          tipo_search = '';
                          filtra();
                        "
                        color="primary"
                        >{{
                          tipo_search == "" ? "mdi-filter" : "mdi-filter-off"
                        }}</v-icon
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" md="2">
                  <v-autocomplete
                    background-color="#ffffff"
                    @change="(sub_famiglia_search = ''), filtra()"
                    dense
                    hide-details
                    :items="actualItems_backup"
                    item-text="id_famiglia"
                    item-value="id_famiglia_R"
                    label="Famiglia"
                    style="display: inline-block; max-width: 350px"
                    v-model="famiglia_search"
                  >
                    <template v-slot:append>
                      <v-icon
                        class="ml-2"
                        @click="
                          famiglia_search = '';
                          filtra();
                        "
                        color="primary"
                        >{{
                          famiglia_search == ""
                            ? "mdi-filter"
                            : "mdi-filter-off"
                        }}</v-icon
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" md="2">
                  <v-autocomplete
                    background-color="#ffffff"
                    @change="filtra"
                    dense
                    hide-details
                    :items="actualItems_backup"
                    item-text="id_tipo_fornitura"
                    item-value="id_tipo_fornitura"
                    label="Fornitura"
                    style="display: inline-block; max-width: 350px"
                    v-model="fornitura_search"
                  >
                    <template v-slot:append>
                      <v-icon
                        class="ml-2"
                        @click="
                          fornitura_search = '';
                          filtra();
                        "
                        color="primary"
                        >{{
                          fornitura_search == ""
                            ? "mdi-filter"
                            : "mdi-filter-off"
                        }}</v-icon
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" md="2">
                  <v-autocomplete
                    background-color="#ffffff"
                    @change="filtra"
                    dense
                    hide-details
                    :items="
                      actualItems_backup.filter(
                        (f) => f.val_int_sub_tipo == tipo_search
                      )
                    "
                    item-text="des_sub_tipo"
                    item-value="id_sub_tipo"
                    label="Sub Tipo"
                    style="display: inline-block; max-width: 350px"
                    v-model="sub_tipo_search"
                  >
                    <template v-slot:append>
                      <v-icon
                        class="ml-2"
                        @click="
                          sub_tipo_search = '';
                          filtra();
                        "
                        color="primary"
                        >{{
                          sub_tipo_search == ""
                            ? "mdi-filter"
                            : "mdi-filter-off"
                        }}</v-icon
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="4" md="2">
                  <v-autocomplete
                    background-color="#ffffff"
                    @change="filtra"
                    dense
                    hide-details
                    :items="
                      actualItems_backup.filter(
                        (f) => f.val_int_sub_famiglia == famiglia_search
                      )
                    "
                    item-text="des_sub_famiglia"
                    item-value="id_sub_famiglia"
                    label="Sub famiglia"
                    style="display: inline-block; max-width: 350px"
                    v-model="sub_famiglia_search"
                  >
                    <template v-slot:append>
                      <v-icon
                        class="ml-2"
                        @click="
                          sub_famiglia_search = '';
                          filtra();
                        "
                        color="primary"
                        >{{
                          sub_famiglia_search == ""
                            ? "mdi-filter"
                            : "mdi-filter-off"
                        }}</v-icon
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-subtitle>
        <v-card-text class="mt-n16" style="max-height: 450px; overflow-y: auto">
          <v-container fluid>
            <v-row>
              <v-col md="12">
                <v-data-table
                  :loading="LoadingVal"
                  :headers="headers"
                  :items="items"
                  class="elevation-1"
                  :dense="true"
                  :options.sync="options_save"
                >
                  <v-progress-linear
                    v-show="progressBar"
                    slot="progress"
                    color="blue"
                    indeterminate
                  ></v-progress-linear>
                  <template v-slot:[`item.quantita`]="{ item }">
                    <v-text-field
                      min="0"
                      dense
                      v-model="item.quantita"
                      type="number"
                      name="quantita"
                      style="max-width: 75px; min-width: 75px"
                      :key="text_field_key"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--   Distinta Base create dialog -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogDistintaBase"
      width="1200"
    >
      <v-card>
        <v-toolbar dense class="indigo darken-1" primary-title>
          <v-toolbar-title class="white--text">Distinta Base</v-toolbar-title>
          <v-spacer></v-spacer>
          <Button
            bottone_class="saveIcon"
            colore_icona="success"
            idForm="ARTICOLO_DISTINTA_BASE"
            idOggetto="SALVA_ARTICOLO_DISTINTABASE"
            mdi_icona="mdi-floppy"
            testo_tooltip="Salva distinta"
            v-on:buttonClick="conferma_update_distinta = true"
          />
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closedialogDistintaBase" small>
                <v-icon class="" v-on="on" v-bind="attrs" color="red"
                  >mdi-window-close</v-icon
                >
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-container fluid>
            <v-form
              v-on:submit.prevent="searchDistintaBase"
              class="mt-n9 ml-n1"
            >
              <v-container>
                <v-row>
                  <v-col cols="12" md="5">
                    <v-text-field
                      :disabled="this.disablesearch === true"
                      type="text"
                      v-model="cod_articolo"
                      label="Ricerca Componente"
                      placeholder="Ricerca Componente"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col class md="1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mt-5" @click="searchDistintaBase" small>
                          <v-icon
                            v-on="on"
                            v-bind="attrs"
                            color="#1a80b6"
                            size="32"
                            >mdi-magnify</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>Cerca </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-row>
              <v-col md="12">
                <v-data-table
                  :loading="LoadingVal"
                  :headers="headers"
                  :items="items"
                  class="elevation-1"
                  :dense="true"
                  :options.sync="options_update"
                >
                  <v-progress-linear
                    v-show="progressBar"
                    slot="progress"
                    color="blue"
                    indeterminate
                  ></v-progress-linear>
                  <template v-slot:[`item.quantita`]="props">
                    <v-text-field
                      solo
                      flat
                      min="0"
                      dense
                      v-model="props.item.quantita"
                      type="number"
                      name="quantita"
                    ></v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Deletion distinta base dialog -->
    <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogEliminaDistintaBase"
      width="400"
    >
      <v-card>
        <v-toolbar dense class="headline red lighten-2 ml-n2" primary-title>
          <v-toolbar-title class="white--text"
            >elimina la distinta base</v-toolbar-title
          >
        </v-toolbar>
        <v-container fluid>
          <v-row>
            <v-col md="1">
              <v-icon color="red">mdi-exclamation-thick</v-icon>
            </v-col>
            <v-col>
              <p>
                Attenzione. Confermi la rimozione del componenti: N':
                {{ this.deletingQuantity }}-{{ this.deletingItemDetail }}
              </p>
            </v-col>
            <v-col></v-col>
          </v-row>
          <v-row>
            <v-col md="5"></v-col>
            <v-col md="3">
              <v-btn
                dark
                tile
                class="mx-auto"
                @click="
                  deleteItem();
                  dialogEliminaDistintaBase = false;
                "
                color="green"
                >Invia</v-btn
              >
            </v-col>
            <v-col md="2">
              <v-btn
                dark
                tile
                class="mr-5"
                color="red"
                @click="dialogEliminaDistintaBase = false"
                >Anulla</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <!-- Distinta Base TreeView -->
    <v-row>
      <v-col>
        <v-hover>
          <template v-slot="{ hover }">
            <v-card :elevation="hover ? 24 : 2">
              <v-snackbar
                content-class="snackbar"
                :color="color"
                right
                v-model="snackbar"
                :timeout="3000"
              >
                <v-icon :size="64">{{ mainIcon }}</v-icon>
                <h2 class="ml-16">{{ snackbar_text }}</h2>
                <v-btn
                  @click="snackbar = false"
                  fab
                  dark
                  text
                  small
                  style="
                    margin-top: -6rem;
                    float: right !important;
                    margin-right: -1rem !important;
                  "
                >
                  <v-icon>mdi-window-close</v-icon>
                </v-btn>
              </v-snackbar>
              <v-toolbar primary-title dense class="indigo darken-1 rounded-t">
                <v-toolbar-title class="white--text">
                  Distinta Base
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!on"
                  @click="showIcons"
                  class="ml-16"
                  color="white"
                  dark
                  fab
                  top
                  tile
                  small
                >
                  <v-icon color="primary">mdi-arrow-collapse</v-icon>
                </v-btn>
                <v-btn
                  v-if="on"
                  dark
                  fab
                  top
                  tile
                  @click="hideIcons"
                  class="ml-16"
                  color="white"
                  small
                >
                  <v-icon color="primary">mdi-arrow-expand</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text
                class="text-left"
                style="overflow: auto; max-height: 600px"
              >
                <v-progress-circular
                  class=""
                  v-show="progressBar1"
                  slot="progress"
                  color="blue"
                  indeterminate
                ></v-progress-circular>
                <v-treeview
                  activatable
                  shaped
                  hoverable
                  :open.sync="open"
                  :items="distintaBaseList"
                  item-key="id"
                  content="6"
                  open-on-click
                >
                  <template v-slot:prepend="{ item, open }">
                    <b class="mr-2">{{ item.indice }}:</b
                    ><v-icon v-if="item.id == 0">{{
                      open ? "mdi-buffer" : "mdi-buffer"
                    }}</v-icon>
                    <v-icon v-if="item.id > 0">{{
                      open ? "mdi-text-short" : "mdi-text-short"
                    }}</v-icon>
                    <template v-if="item.id >= -1">
                      N°
                      {{
                        item.quantita != null &&
                        item.quantita != undefined &&
                        item.quantita != ""
                          ? item.quantita.toString().replace(".", ",")
                          : 0
                      }}
                      {{ item.cod_articolo }}
                    </template>
                  </template>
                  <template slot="append" slot-scope="{ item }">
                    <span v-show="item.depth == 0 && item.id_rif == -1">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="
                              $event.stopPropagation();
                              showModal();
                            "
                            small
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="primary"> mdi-plus </v-icon>
                          </v-btn>
                        </template>
                        <span>Inserisci Componente</span>
                      </v-tooltip>
                    </span>

                    <!-- Bottone per il Livello Qualità Accettabile -->
                    <span v-show="item.depth == 1 && item.id_rif == 0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mr-1"
                            @click="
                              $event.stopPropagation();
                              setLQA(item);
                            "
                            v-on="on"
                            small
                            :color="item.lqa === 1 ? 'success' : ''"
                          >
                            <v-icon
                              :color="item.lqa === 1 ? 'white' : 'primary'"
                              >mdi-link-box-variant</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Tracciabilità Materia Prima</span>
                      </v-tooltip>
                    </span>

                    <!-- Bottone per il materiale sotto-lotto (tracciabilità lotti) -->
                    <span v-show="item.depth == 1 && item.id_rif == 0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mr-1"
                            @click="
                              $event.stopPropagation();
                              setMaterialeSottoLotto(item);
                            "
                            v-on="on"
                            small
                            :color="
                              item.materiale_sotto_lotto === 1 ? 'success' : ''
                            "
                          >
                            <v-icon
                              :color="
                                item.materiale_sotto_lotto === 1
                                  ? 'white'
                                  : 'primary'
                              "
                              >mdi-map-marker-path</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Materiale Sotto-Lotto</span>
                      </v-tooltip>
                    </span>

                    <span v-show="item.depth == 1 && item.id_rif == 0">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            @click="
                              $event.stopPropagation();
                              getDetail(item);
                            "
                            v-on="on"
                            small
                          >
                            <v-icon color="blue">mdi-eye</v-icon>
                          </v-btn>
                        </template>
                        <span>Dettaglio Componente</span>
                      </v-tooltip>
                    </span>
                    <span v-show="item.depth == 1 && item.id_rif == 0">
                      <Button
                        classe_bottone="ml-1"
                        colore_icona="primary"
                        idForm="ARTICOLO_DISTINTA_BASE"
                        idOggetto="MODIFICA_ARTICOLO_DISTINTABASE"
                        mdi_icona="mdi-pencil"
                        testo_tooltip="Modifica Componente"
                        v-on:buttonClick="updateItem(item)"
                      />
                    </span>

                    <span v-show="item.depth == 1 && item.id_rif == 0">
                      <Button
                        classe_bottone="ml-1"
                        colore_icona="error"
                        idForm="ARTICOLO_DISTINTA_BASE"
                        idOggetto="ELIMINA_ARTICOLO_DISTINTABASE"
                        mdi_icona="mdi-window-close"
                        testo_tooltip="Cancella Componente"
                        v-on:buttonClick="selectDistinta(item)"
                      />
                    </span>
                    <span v-show="(item.depth == 2) && (db_corrente == 'db_fiorenzo')">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn @click.stop="openDialog(item)" small v-on="on">
                            <v-icon color="primary">mdi-image</v-icon>
                          </v-btn>
                        </template>
                        <span>Inserisci immagine per opzione</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-treeview>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </template>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Dialog di conferma della modifica di un componente -->
    <v-dialog v-model="conferma_save_distinta" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Salvataggio
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi l'aggiunta di questi componenti nella distinta base
            dell'articolo
          </span>
          <div class="my-5">
            <span style="font-size: 25px">
              <b>{{
                distintaBaseList.length > 0 ? distintaBaseList[0].name : ""
              }}</b>
            </span>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="conferma_save_distinta = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Annulla</span>
                </v-tooltip>

                <!-- Bottone di conferma -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="saveDistinta"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Conferma</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma della modifica di un componente -->
    <v-dialog v-model="conferma_update_distinta" width="unset">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Modifica
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="font-size: 18px">
            Confermi di voler salvare le modifiche alla quantità del componente
            nella distinta base dell'articolo
          </span>
          <div class="my-5">
            <span style="font-size: 25px">
              <b>{{
                distintaBaseList.length > 0 ? distintaBaseList[0].name : ""
              }}</b>
            </span>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-container class="ma-0 pa-0">
            <v-row align="center" justify="center">
              <v-col cols="12" align="center" justify="center">
                <!-- Bottone di annullamento -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="conferma_update_distinta = false"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="error"> mdi-close </v-icon>
                    </v-btn>
                  </template>
                  <span>Annulla</span>
                </v-tooltip>

                <!-- Bottone di conferma -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-5"
                      @click="updateDistinta"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="success"> mdi-check </v-icon>
                    </v-btn>
                  </template>
                  <span>Conferma</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di inserimento immagine per opzione -->
    <v-dialog v-model="uploadDialog" width="80vw" max-height="70vh">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Carica Immagine</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeUploadDialog">
            <v-icon color="red">mdi-window-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
            <img
              :src="newPreviewImage || previewImage"
              style="height: 30vh;"
            />
            <p
              v-show="!previewImage && !newPreviewImage"
              style="font-size: 25px; margin: 1rem 3rem"
            >
              Nessuna immagine caricata. Seleziona un'immagine da caricare.
            </p>
            <input
              type="file"
              accept="image/*"
              @change="setPreview"
              ref="fileInput"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="caricaImmagine(id_opzione_corrente)">
            Carica Immagine
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>
<script>
import Button from "@/components/TOOLS/FormComponentPermissions/Button.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "distintaBase",
  props: ["pdata"],
  components: {
    Articolo: () => import("../Articolo"),
    Button,
    SnackbarQV,
  },
  data() {
    return {
      // Search Articolo Distina base header
      headers: [
        {
          text: "Q.tà Distinta",
          value: "quantita",
        },
        {
          text: "Codice Componente",
          value: "cod_articolo",
        },
        {
          text: "Descrizione",
          value: "des_articolo",
        },
        {
          text: "Tipo Articolo",
          value: "tipo_articolo",
        },
        {
          text: "Sub Tipo",
          value: "des_sub_tipo",
        },
        {
          text: "Fornitura",
          value: "id_tipo_fornitura",
        },
        {
          text: "Famiglia",
          value: "id_famiglia",
        },
        {
          text: "Sub famiglia",
          value: "des_sub_famiglia",
        },
      ],
      // overlay variable
      overlay: false,
      // delete confirmation dialog
      conferma_save_distinta: false,
      conferma_update_distinta: false,
      dialogElimina: false,
      selectedDistinta: {},
      item: {},
      ids: [],
      dialogDistintaBase: false,
      LoadingVal: false,
      progressBar: true,
      progressBar1: true,
      recursiveId: null,
      dialogArticolo: false,
      openAll: false,
      on: true,
      deletingQuantity: 0,
      deletingItemDetail: "",
      dialogEliminaDistintaBase: false,
      disablesearch: false,
      open: [0],
      hideicons: true,
      quantita: 0,
      items: [],
      cod_articolo: "",
      options_save: {},
      options_update: {},
      text_field_key: 1,
      distintaBaseList: [], //array cartelle
      dialog: false,
      uploadDialog: false,
      previewImage: null,
      base64Opzione: "",
      images: null,
      newPreviewImage: null,
      db_corrente: null,
      // Snackbar Variables
      color: "",
      snackbar: false,
      mainIcon: "",
      snackbar_text: "",
      id_articolo: this.pdata.id_articolo,
      id_opzione_corrente: 0,
      //variabili per filtri
      actualItems_backup: [],
      filtro_visible: "",
      tipo_search: "",
      famiglia_search: "",
      fornitura_search: "",
      sub_tipo_search: "",
      sub_famiglia_search: "",
    };
  },
  mounted() {
    this.db_corrente = localStorage.dbname
    this.GetDistintaBase();
    this.getImmagineOpzione();
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  methods: {
    setLQA(arg) {
      this.distintaBaseList[0].children.forEach((c) => {
        if (c.id == arg.id) {
          c.lqa = c.lqa == 0 ? 1 : 0;
        }
      });
      this.updateDistinta();
    },
    setMaterialeSottoLotto(arg) {
      this.distintaBaseList[0].children.forEach((c) => {
        if (c.id !== arg.id) {
          c.materiale_sotto_lotto = 0;
        } else {
          c.materiale_sotto_lotto = 1;
        }
      });
      this.updateDistinta();
    },
    updatepagination() {
      this.text_field_key = this.text_field_key === 0 ? 1 : 0;
    },
    resetFiltro() {
      // Resetto i filtri
      this.tipo_search = "";
      this.fornitura_search = "";
      this.famiglia_search = "";
      this.sub_tipo_search = "";
      this.sub_famiglia_search = "";

      // Nascondo i filtri
      this.filtro_visible = false;

      // Ricarico la tabella
      this.items = Array.from(this.actualItems_backup);
    },
    filtra() {
      console.log("entrato");
      console.log("id_sub_tipo_search", this.tipo_search);
      console.log("id_sub_famiglia_search", this.famiglia_search);
      let articoli_tmp = [];
      this.actualItems_backup.forEach((elem) => {
        articoli_tmp.push(elem);
      });

      // Filtro il cod_richiesta
      if (this.tipo_search != "") {
        // Faccio un array temporaneo
        let res = [];

        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        articoli_tmp.forEach((elem) => {
          if (elem.id_tipo_R == this.tipo_search) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        articoli_tmp = res;
      }

      // Filtro il richiedente
      if (this.famiglia_search != "") {
        // Faccio un array temporaneo
        let res = [];

        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        articoli_tmp.forEach((elem) => {
          if (elem.id_famiglia_R == this.famiglia_search) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        articoli_tmp = res;
      }
      if (this.fornitura_search != "") {
        // Faccio un array temporaneo
        let res = [];

        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        articoli_tmp.forEach((elem) => {
          if (elem.id_tipo_fornitura == this.fornitura_search) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        articoli_tmp = res;
      }

      // Filtro la data richiesta

      // Filtro la sede della richiesta
      if (this.sub_tipo_search != "") {
        // Faccio un array temporaneo
        let res = [];

        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        articoli_tmp.forEach((elem) => {
          if (elem.id_sub_tipo == this.sub_tipo_search) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".\
        articoli_tmp = res;
      }

      // Filtro la struttura della richiesta
      if (this.sub_famiglia_search != "") {
        // Faccio un array temporaneo
        let res = [];

        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        articoli_tmp.forEach((elem) => {
          if (elem.id_sub_famiglia == this.sub_famiglia_search) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        articoli_tmp = res;
      }

      this.items = articoli_tmp;
    },

    // Get Distinta Base
    GetDistintaBase() {
      // In order to get distinta base of the Articolo to populate treeview
      let getdistintabase = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticolidistintabase",
          token: localStorage.getItem("user_token"),
          id_articolo: this.id_articolo,
        },
      };
      this.$store.dispatch("api", getdistintabase).then((res) => {
        this.distintaBaseList = res.data;
        const setDepth = (list, depth) => {
          list.forEach((item) => {
            item.depth = depth;
            if (item.children && item.children.length > 0) {
              setDepth(item.children, depth + 1);
            }
          });
        };
        setDepth(this.distintaBaseList, 0);
        if (this.distintaBaseList.length > 0) {
          this.progressBar1 = false;
        }
        if (this.distintaBaseList.length === 0) {
          this.distintaBaseList = [];
        }
        this.distintaBaseList.map((el) => {
          if (el.children.length > 0) {
            el.children.map((child) => {
              this.ids.push(child.id);
            });
          }
          this.ids.push(el.id);
        });
        /* Assegno un indice a tutti gli elementi di "distintaBaseList"
         * e ai loro figli per stampare il numero di riga nella treeview. */
        this.setIndiceRicorsivo(this.distintaBaseList);
      });
    },
    //Function to select distinta to delete before delete
    selectDistinta(item) {
      this.selectedDistinta = item;
      this.dialogElimina = true;
    },
    // in order to deselect selected item
    delSelectedItem() {
      this.selectedDistinta = {};
      this.dialogElimina = false;
    },
    // clsoing modal
    closedialogDistintaBase() {
      this.dialogDistintaBase = false;
      this.item = null;
      this.items = [];
      this.GetDistintaBase();
    },
    // In order to update a single component
    updateDistinta() {
      this.conferma_update_distinta = false;

      this.overlay = true;
      this.distintaBaseList[0].children.map((it) => {
        it.validita = 1;
        it.children = [];
      });
      this.dialogDistintaBase = false;
      let setdistintabase1 = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticolidistintabase",
          id_articolo: this.id_articolo,
          token: localStorage.getItem("user_token"),
          distinta_base: this.distintaBaseList,
        },
      };
      this.$store.dispatch("api", setdistintabase1).then(() => {
        this.snackbar = true;
        this.overlay = false;
        this.snackbar_text = "Modifica effettuata con successo!";
        this.color = "green darken-3";
        this.mainIcon = "mdi-check-circle";
        this.item = null;
        this.items = [];
      });
      this.dialogDistintaBase = false;
    },
    // opening recursive modal for element detail
    getDetail(e, item) {
      this.dialogArticolo = true;
      this.recursiveId = item.id;
    },
    //close detaol modal
    closedetailModal() {
      this.dialogArticolo = false;
    },
    // removing single element
    removefromDistinta(i) {
      this.distintaBaseList[0].children.splice(i, 1);
    },
    // In order to delete one componente of distinta base
    deleteFolder() {
      this.overlay = true;
      let data = this.selectedDistinta;
      data.validita = 0;
      let i = this.distintaBaseList[0].children.findIndex((it) => {
        return it.id_distinta_base === data.id_distinta_base;
      });
      this.distintaBaseList[0].children.splice(i, 1, data);
      this.distintaBaseList[0].children.map((it) => (it.children = []));
      let deldistintabase = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticolidistintabase",
          id_articolo: this.id_articolo,
          token: localStorage.getItem("user_token"),
          distinta_base: this.distintaBaseList,
        },
      };
      this.$store.dispatch("api", deldistintabase).then((res) => {
        this.overlay = false;
        if (res.data) {
          this.snackbar = true;
          this.snackbar_text = "Modifica effettuata con successo!";
          this.color = "green darken-3";
          this.mainIcon = "mdi-check-circle";
          this.removefromDistinta(i);
        }
      });
      this.dialogElimina = false;
    },
    // to taggle open all icon
    hideIcons() {
      this.hideicons = false;
      this.on = false;
      this.openAll = true;
      this.open = this.ids;
    },
    // to togggle close all icon
    showIcons() {
      this.hideicons = true;
      this.openAll = false;
      this.open = [];
      this.on = true;
    },
    // in order to disable the search field when in update mode
    updateItem(val) {
      this.dialogDistintaBase = true;
      this.disablesearch = true;
      this.item = val;
      val.cod_articolo = val.id;
      val.des_articolo = val.name;
      this.items.push(val);
    },
    // search articolo to add as component of distinta
    searchDistintaBase(evt) {
      this.LoadingVal = true;
      this.progressBar = true;
      this.overlay = true;
      evt.preventDefault();
      let getdistintabase = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          cod_articolo: this.cod_articolo,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", getdistintabase).then((res) => {
        this.actualItems_backup = res.data.lista;
        this.items = res.data.lista;
        this.overlay = false;
        if (this.items.length === 0) {
          this.snackbar = true;
          this.snackbar_text = "L'articolo non è stato trovato. Riprova !";
          this.mainIcon = "mdi-close-circle";
          this.color = "red accent-4";
          this.progressBar = false;
          this.LoadingVal = false;
        }
        // In order to remove the main articolo from search it is not possible to add parent component to add as a children
        if (this.items.length > 0) {
          this.progressBar = false;
          this.LoadingVal = false;
          let i = this.items.findIndex(
            (it) => it.cod_articolo == this.pdata.cod_articolo
          );
          if (i > -1) {
            this.items.splice(i, 1);
          }
        }
        this.items.map((el) => (el.quantita = 0));
      });
    },
    // search articolo modal
    showModal() {
      this.dialog = true;
      this.disablesearch = false;
      this.items = [];
    },
    // in order to get exact distinta before save
    setDistinta(val) {
      this.overlay = true;
      const newDistinta = val;
      newDistinta[0].children.map((el) => (el.children = []));
      let setdistintabase = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setarticolidistintabase",
          id_articolo: this.id_articolo,
          token: localStorage.getItem("user_token"),
          distinta_base: newDistinta,
        },
      };
      this.$store.dispatch("api", setdistintabase).then((res) => {
        this.overlay = false;
        this.distintaBaseList = res.data;
        this.setIndiceRicorsivo(this.distintaBaseList);
        this.snackbar = true;
        this.snackbar_text = "Modifica effettuata con successo!";
        this.color = "green darken-3";
        this.mainIcon = "mdi-check-circle";
      });
    },
    // to add new components to distinta base
    saveDistinta() {
      this.conferma_save_distinta = false;

      const filteredObject = Array.from(
        this.items.filter((e) => e.quantita > 0)
      );
      this.overlay = true;

      /* Eseguo un controllo per verificare se il
       * nuovo elemento era già stato inserito. */
      let chk_ricorre = false;

      filteredObject.forEach((el_new) => {
        this.distintaBaseList[0].children.forEach((el_old) => {
          if (el_new.id_articolo === el_old.id_componente) {
            chk_ricorre = true;
          }
        });
      });

      if (chk_ricorre === true) {
        this.overlay = false;
        this.$refs.SnackbarQV.print(
          "orange",
          "Articolo già presente in Distinta Base. Per cambiare la quantità usare le funzioni di modifica."
        );
        return;
      }

      // Parso la quantità in numero in virgola mobile
      filteredObject.forEach((el) => {
        if (el.quantita > 0) {
          // Forzo un numero in virgola mobile
          el.quantita = parseFloat(el.quantita);
        }
      });

      var ctr = 0;
      filteredObject.map((el) => {
        let getdistintabase = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getarticolidistintabase",
            token: localStorage.getItem("user_token"),
            id_articolo: el.id_articolo,
          },
        };
        this.$store.dispatch("api", getdistintabase).then((res) => {
          this.overlay = false;
          let getresult = res.data;
          let element = {};
          element.id_distinta_base = -1;
          element.id_articolo = this.id_articolo;
          element.id_componente = el.id_articolo;
          element.id = parseInt(getresult[0].id);
          element.name = getresult[0].name;
          element.quantita = el.quantita;
          element.validita = 1;
          element.id_rif = 0;
          element.children = [];
          ctr++;
          this.distintaBaseList[0].children.push(Object.assign({}, element));
          this.distintaBaseList[0].validita = 1;
          if (filteredObject.length === ctr) {
            this.setDistinta(this.distintaBaseList);
          }
        });
      });
      this.dialog = false;
      this.items = [];
      this.item = null;
      this.cod_articolo = "";
    },
    hideModal() {
      this.items = [];
      this.dialog = false;
      this.disablesearch = false;
      this.cod_articolo = "";
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    // In order to add numbering to the distinta base
    setIndiceRicorsivo(array) {
      array.forEach((elem) => {
        elem.indice = array.indexOf(elem) + 1;
        if (elem.children && elem.children.length > 0) {
          this.setIndiceRicorsivo(elem.children);
        }
      });
    },
    setPreview() {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.newPreviewImage = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    caricaImmagine(id) {
      const fileInput = this.$refs.fileInput;
      const file = fileInput.files[0];
      if (!file) {
        this.$refs.SnackbarQV.print("orange", "Seleziona un'immagine");
        return;
      }

      const reader = new FileReader();
      reader.onload = () => {
        this.base64Opzione = reader.result;
        this.previewImage = this.base64Opzione;
        this.uploadDialog = false;
        this.newPreviewImage = null;

        if (this.base64Opzione !== "") {
          // Save image to the database
          let setImmagineOpzioneArticolo = {
            controller: "Magazzino",
            method: "PUT",
            richiesta: {
              action: "setimmagineopzionearticolo",
              token: localStorage.getItem("user_token"),
              id_articolo: id,
              base64: this.base64Opzione,
            },
          };
          this.$store
            .dispatch("api", setImmagineOpzioneArticolo)
            .then((res) => {
              if (res.status === 200) {
                this.$refs.SnackbarQV.print(
                  "success",
                  "Immagine assegnata correttamente all'opzione."
                );
                fileInput.value = "";
                this.getImmagineOpzione();
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  "Errore nella comunicazione col server, non è stato possibile caricare i dati."
                );
              }
            })
            .catch(() => {
              this.$refs.SnackbarQV.print(
                "error",
                "Errore nella comunicazione col server, non è stato possibile caricare i dati."
              );
            });
        }
      };
      reader.readAsDataURL(file);
    },
    closeUploadDialog() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
      this.previewImage = "";
      this.newPreviewImage = null;
      this.uploadDialog = false;
    },
    getImmagineOpzione() {
      let getImmagineOpzione = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getimmagineopzione",
          token: localStorage.getItem("user_token"),
          id_articolo: this.pdata.id_articolo,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", getImmagineOpzione)
        .then((response) => {
          this.overlay = false;
          if (response.data.response && response.data.result) {
            this.images = response.data.result;
          }
        })
        .catch((error) => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
          console.error("Error:", error);
        });
    },
    openDialog(item) {
      this.id_opzione_corrente = item.id_componente;
      this.previewImage = this.images[this.id_opzione_corrente];
      this.uploadDialog = true;
    },
  },
  watch: {
    options_save: {
      handler() {
        this.updatepagination();
      },
      deep: true,
    },
    options_update: {
      handler() {
        this.updatepagination();
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.artDialog {
  overflow-x: hidden;
}
</style>
